import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const withDateInput = (InputComponent) => {
   const WrappedComponent = (props) => {
      return (
         <InputComponent
            {...props.field}
            onChange={props.onChange}
            isDisabled={props.isDisabled}
            isTouched={!!props.form.touched[props.field.name]}
            errorMessage={props.errorMessage}
            minDate={props.minDate}
         />
      );
   };

   WrappedComponent.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.objectOf(PropTypes.any).isRequired,
      }).isRequired,
      isDisabled: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
      errorMessage: PropTypes.string,
      minDate: PropTypes.instanceOf(Date),
   };

   WrappedComponent.defaultProps = {
      isDisabled: false,
      errorMessage: undefined,
      minDate: undefined,
   };

   return WrappedComponent;
};

export default withDateInput;
